import React from "react";

export default function JS_Abstraction() {
  return (
    <div className="tutorial-container">
      <h1>JS Abstraction</h1>
      <p>
        This tutorial explains the concept of JS Abstraction in JavaScript OOPs.
      </p>
    </div>
  );
}
